// API Configuration
export const API_BASE_URL = import.meta.env.VITE_API_URL || '/api/v1';

// API Endpoints
export const API_ENDPOINTS = {
  auth: {
    login: `${API_BASE_URL}/auth/login`,
    logout: `${API_BASE_URL}/auth/logout`,
    profile: `${API_BASE_URL}/auth/profile`,
    refresh: `${API_BASE_URL}/auth/refresh`,
    forgotPassword: `${API_BASE_URL}/auth/forgot-password`,
    resetPassword: `${API_BASE_URL}/auth/reset-password`,
    changePassword: `${API_BASE_URL}/auth/change-password`,
  },
  customers: {
    list: `${API_BASE_URL}/customers`,
    create: `${API_BASE_URL}/customers`,
    update: (id: string) => `${API_BASE_URL}/customers/${id}`,
    delete: (id: string) => `${API_BASE_URL}/customers/${id}`,
    get: (id: string) => `${API_BASE_URL}/customers/${id}`,
  },
  appointments: {
    list: `${API_BASE_URL}/appointments`,
    create: `${API_BASE_URL}/appointments`,
    update: (id: string) => `${API_BASE_URL}/appointments/${id}`,
    delete: (id: string) => `${API_BASE_URL}/appointments/${id}`,
    get: (id: string) => `${API_BASE_URL}/appointments/${id}`,
  },
  services: {
    list: `${API_BASE_URL}/services`,
    create: `${API_BASE_URL}/services`,
    update: (id: string) => `${API_BASE_URL}/services/${id}`,
    delete: (id: string) => `${API_BASE_URL}/services/${id}`,
    get: (id: string) => `${API_BASE_URL}/services/${id}`,
  },
  staff: {
    list: `${API_BASE_URL}/staff`,
    create: `${API_BASE_URL}/staff`,
    update: (id: string) => `${API_BASE_URL}/staff/${id}`,
    delete: (id: string) => `${API_BASE_URL}/staff/${id}`,
    get: (id: string) => `${API_BASE_URL}/staff/${id}`,
  },
  inventory: {
    list: `${API_BASE_URL}/inventory`,
    create: `${API_BASE_URL}/inventory`,
    update: (id: string) => `${API_BASE_URL}/inventory/${id}`,
    delete: (id: string) => `${API_BASE_URL}/inventory/${id}`,
    get: (id: string) => `${API_BASE_URL}/inventory/${id}`,
  },
  analytics: {
    dashboard: `${API_BASE_URL}/analytics/dashboard`,
    revenue: `${API_BASE_URL}/analytics/revenue`,
    appointments: `${API_BASE_URL}/analytics/appointments`,
    customers: `${API_BASE_URL}/analytics/customers`,
  },
  campaigns: {
    list: `${API_BASE_URL}/campaigns`,
    create: `${API_BASE_URL}/campaigns`,
    update: (id: string) => `${API_BASE_URL}/campaigns/${id}`,
    delete: (id: string) => `${API_BASE_URL}/campaigns/${id}`,
    get: (id: string) => `${API_BASE_URL}/campaigns/${id}`,
  },
} as const;

// Helper function for making API requests
export const apiRequest = async (url: string, options: RequestInit = {}): Promise<any> => {
  const token = localStorage.getItem('token');

  const defaultHeaders: HeadersInit = {
    'Content-Type': 'application/json',
  };

  if (token) {
    defaultHeaders.Authorization = `Bearer ${token}`;
  }

  const config: RequestInit = {
    ...options,
    headers: {
      ...defaultHeaders,
      ...options.headers,
    },
  };

  const response = await fetch(url, config);

  if (!response.ok) {
    const error = await response.json();
    throw new Error(error.message || 'API request failed');
  }

  return response.json();
};
